<template>
  <div class="px-2 order-action-surface">
    <div class="contract-shortcut-action pt-3">
      <div v-if="currentContractCreditAlert" class="contract-credit-bubbles">
        <transition name="credit-bubbles" mode="out-in" appear>
          <div
            :key="currentContractCreditAlert.company_id"
            class="contract-credit-bubble"
            :class="
              'contract-credit-bubble--' +
              currentContractCreditAlert.credit_state
            "
          >
            <button
              type="button"
              class="contract-credit-bubble__close"
              aria-label="Hide company credit alert"
              @click="dismissCurrentContractCreditAlert"
            >
              <v-icon small>close</v-icon>
            </button>
            <v-icon class="contract-credit-bubble__icon" small>
              warning
            </v-icon>
            <div>
              <strong>
                บริษัท {{ currentContractCreditAlert.company_name }}
              </strong>
              มีเครดิต
              {{
                formatCreditAmount(currentContractCreditAlert.current_balance)
              }}
              บาท ไม่พอสำหรับออเดอร์ถัดไป
              {{
                formatCreditAmount(currentContractCreditAlert.next_order_price)
              }}
              บาท
              <span class="contract-credit-bubble__hint">
                Contract ยังสร้างออเดอร์ต่อได้
              </span>
            </div>
          </div>
        </transition>
        <div
          v-if="contractCreditAlerts.length > 1"
          class="contract-credit-pager"
        >
          <button
            type="button"
            class="contract-credit-pager__button"
            aria-label="Previous company credit alert"
            @click="showPreviousContractCreditAlert"
          >
            <v-icon small>chevron_left</v-icon>
          </button>
          <span class="contract-credit-pager__position">
            {{ contractCreditAlertPage + 1 }} /
            {{ contractCreditAlerts.length }}
          </span>
          <button
            type="button"
            class="contract-credit-pager__button"
            aria-label="Next company credit alert"
            @click="showNextContractCreditAlert"
          >
            <v-icon small>chevron_right</v-icon>
          </button>
        </div>
      </div>
      <v-btn
        class="contract-shortcut-btn"
        color="#fddf00"
        depressed
        @click="contractDialog = true"
      >
        สัญญา Messenger
      </v-btn>
    </div>

    <v-dialog
      v-model="contractDialog"
      max-width="1480"
      scrollable
      content-class="call-center-contract-dialog"
    >
      <v-card class="call-center-glass-card">
        <v-card-title class="shortcut-dialog-header">
          <div>
            <div class="shortcut-dialog-eyebrow">เมนูลัด Call Center</div>
            <div class="shortcut-dialog-title">จัดการสัญญา Messenger</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="contractDialog = false"
            ><v-icon>close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="shortcut-dialog-content">
          <messenger-contract-manager
            v-if="contractDialog"
            embedded
            :initial-province="callCenterProvince"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <template>
      <v-tabs v-model="tabs" color="transparent">
        <v-tab
          href="#tab-1"
          active-class="white--text tab-color"
          @click="order_type_all = 1"
          >All</v-tab
        >
        <v-tab
          href="#tab-2"
          active-class="white--text tab-color"
          @click="order_type_all = 2"
        >
          Food Delivery
          <v-btn fab outline color="red" style="height: 28px; width: 28px">{{
            (order_count.we_order_status ? checkCountOrder("we") : 0) +
            (order_count.we_order_status ? checkCountOrder("fr") : 0)
          }}</v-btn>
        </v-tab>
        <v-tab
          href="#tab-3"
          active-class="white--text tab-color"
          @click="order_type_all = 3"
        >
          Messenger
          <v-btn fab outline color="red" style="height: 28px; width: 28px">{{
            order_count.me_order_status ? checkCountOrder("me") : 0
          }}</v-btn>
        </v-tab>
      </v-tabs>
    </template>
    <v-tabs-items touchless v-model="tabs" class="white elevation-1">
      <v-tab-item
        v-for="i in 3"
        :key="i"
        :value="'tab-' + i"
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <v-card flat style="border: 1px solid #333">
          <v-data-table
            :headers="tableHeaders"
            :items="filtersItems(order_status)"
            :loading="fetching_order"
            :rows-per-page-items="[
              25,
              50,
              100,
              { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
            ]"
          >
            <template slot="items" slot-scope="props">
              <tr style="background-color: #eeeeee">
                <td class="text-xs-left">{{ props.item.order_code }}</td>
                <td class="text-xs-left">
                  {{
                    props.item.order_customer_full_name ||
                    props.item.order_business_full_name
                  }}
                </td>
                <v-select
                  :items="statusOrderWE"
                  v-model="type[props.index]"
                  @change="changeStatus($event, props.item, props.index)"
                  item-text="name"
                  :label="checkLabel(props.item.order_status)"
                  item-value="value"
                  style="width: 130px"
                  :loading="changing_status.includes(props.item.order_id)"
                  :disabled="
                    changing_status.includes(props.item.order_id) ||
                    (order_status == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    order_status == 0 ||
                    isEditOrder
                  "
                  v-if="
                    props.item.order_type == 1 || props.item.order_type == 3
                  "
                ></v-select>
                <v-select
                  :items="statusOrderME"
                  v-model="type[props.index]"
                  @change="changeStatus($event, props.item, props.index)"
                  item-text="name"
                  :label="checkLabel(props.item.order_status)"
                  item-value="value"
                  style="width: 130px"
                  :loading="changing_status.includes(props.item.order_id)"
                  :disabled="
                    changing_status.includes(props.item.order_id) ||
                    (order_status == 6 &&
                      $store.state.permission.order.edit_view != 3) ||
                    (order_status == 7 &&
                      $store.state.permission.order.edit_view != 3) ||
                    order_status == 0 ||
                    isEditOrder
                  "
                  v-if="props.item.order_type == 2"
                ></v-select>

                <td class="text-xs-center">
                  <!--  -->
                  <countdown
                    :time="
                      calTime(
                        props.item.order_time_start,
                        props.item.order_code
                      )
                    "
                  >
                    <template slot-scope="props1">
                      <div
                        :style="
                          props1.totalMilliseconds == 0 ? 'color:green;' : null
                        "
                      >
                        {{
                          NotiReadey(props1.totalMilliseconds, props.item) == 0
                            ? "Ready"
                            : amountCharTime(props1.days * 24 + props1.hours) +
                              ":" +
                              amountCharTime(props1.minutes) +
                              ":" +
                              amountCharTime(props1.seconds)
                        }}
                      </div>
                    </template>
                  </countdown>
                </td>
                <td class="text-xs-center">
                  {{ props.item.order_rider_full_name }}
                </td>
                <td v-if="isAutoDispatchFeatureEnabled" class="text-xs-center">
                  <v-chip
                    v-if="dispatchStatusLabel(props.item)"
                    small
                    dark
                    :color="dispatchStatusColor(props.item)"
                  >
                    {{ dispatchStatusLabel(props.item) }}
                  </v-chip>
                  <span v-else>-</span>
                </td>
                <!-- <td class="text-xs-center">{{ props.item.order_store_name }}</td> -->
                <td class="text-xs-center">
                  {{
                    props.item.order_discount == null
                      ? null
                      : props.item.order_discount_code
                  }}
                </td>
                <td class="text-xs-center">
                  {{
                    props.item.order_net_price
                      ? parseFloat(props.item.order_net_price).toFixed(2)
                      : "0.00"
                  }}
                </td>
                <td class="text-xs-center">
                  <v-icon
                    medium
                    :color="
                      props.item.order_is_paymented != 1 ||
                      props.item.order_payment_type == 2 ||
                      props.item.order_payment_type == 5
                        ? 'green'
                        : 'red'
                    "
                    >{{
                      props.item.order_payment_type == 1
                        ? "attach_money"
                        : props.item.order_payment_type == 2
                        ? "credit_card"
                        : props.item.order_payment_type == 3
                        ? "phone_iphone"
                        : props.item.order_payment_type == 4
                        ? "currency_exchange"
                        : props.item.order_payment_type == 5
                        ? "corporate_fare"
                        : ""
                    }}</v-icon
                  >
                </td>

                <td class="text-xs-center">
                  {{
                    props.item.order_time_start == null
                      ? null
                      : props.item.order_time_start.substring(0, 10) +
                        " - " +
                        props.item.order_time_start.substring(11, 16) +
                        " น."
                  }}
                </td>
                <td class="text-xs-center">
                  {{
                    props.item.order_time_end == null
                      ? null
                      : props.item.order_time_end.substring(0, 10) +
                        " - " +
                        props.item.order_time_end.substring(11, 16) +
                        " น."
                  }}
                </td>
                <!-- <td class="justify-center layout px-0">
            <v-btn small @click="toDetail()">Details</v-btn>
                </td>-->

                <td class="justify-center layout px-0">
                  <order-incentive-dialog
                    v-if="[1, 2].includes(Number(props.item.order_type))"
                    :order-id="props.item.order_id"
                    :order-code="props.item.order_code"
                    :province="callCenterProvince"
                    :order-status="props.item.order_status"
                    :value="props.item.order_incentive"
                    icon
                    @saved="$set(props.item, 'order_incentive', $event)"
                  />
                  <v-tooltip
                    top
                    v-if="
                      props.item.order_type == 1 || props.item.order_type == 3
                    "
                  >
                    <v-btn
                      slot="activator"
                      small
                      icon
                      @click="toDetail(props.item.order_id)"
                    >
                      <v-icon small>{{
                        (props.item.order_status == 6 &&
                          $store.state.permission.order.edit_view != 3) ||
                        (props.item.order_status == 7 &&
                          $store.state.permission.order.edit_view != 3) ||
                        isEditOrder
                          ? "remove_red_eye"
                          : "edit"
                      }}</v-icon>
                    </v-btn>
                    <span>{{
                      (props.item.order_status == 6 &&
                        $store.state.permission.order.edit_view != 3) ||
                      (props.item.order_status == 7 &&
                        $store.state.permission.order.edit_view != 3) ||
                      isEditOrder
                        ? "View"
                        : "View/Edit"
                    }}</span>
                  </v-tooltip>
                  <v-tooltip top v-if="props.item.order_type == 2">
                    <v-btn
                      slot="activator"
                      small
                      icon
                      @click="toMessengerDetail(props.item.order_id)"
                    >
                      <v-icon small>{{
                        (props.item.order_status == 6 &&
                          $store.state.permission.order.edit_view != 3) ||
                        (props.item.order_status == 7 &&
                          $store.state.permission.order.edit_view != 3)
                          ? "remove_red_eye"
                          : "edit"
                      }}</v-icon>
                    </v-btn>
                    <span>{{
                      (props.item.order_status == 6 &&
                        $store.state.permission.order.edit_view != 3) ||
                      (props.item.order_status == 7 &&
                        $store.state.permission.order.edit_view != 3)
                        ? "View"
                        : "View/Edit"
                    }}</span>
                  </v-tooltip>
                </td>
              </tr>
              <tr>
                <td
                  colspan="8"
                  v-if="
                    props.item.order_store == null && props.item.order_type == 2
                  "
                >
                  <v-card flat color="transparent">
                    <v-card-text class="text-xs-left pl-0">
                      <ul>
                        <li>
                          <span style="font-weight: bold">Start</span>
                          :
                          {{
                            props.item.order_point
                              ? props.item.order_point.order_point_first
                              : ""
                          }}
                        </li>
                        <li>
                          <span style="font-weight: bold">End</span>
                          &nbsp; &nbsp; :
                          {{
                            props.item.order_point
                              ? props.item.order_point.order_point_last
                              : ""
                          }}
                        </li>
                      </ul>
                    </v-card-text>
                  </v-card>
                </td>
                <td
                  v-if="
                    props.item.order_use_merchant === true &&
                    props.item.order_type == 1
                  "
                >
                  <v-chip
                    small
                    depressed
                    color="orange"
                    class="white--text"
                    style="border-radius: 10px"
                    >Merchant</v-chip
                  >
                </td>
                <td v-else></td>
                <td
                  v-if="
                    props.item.order_payment_method === 2 &&
                    props.item.order_type == 1
                  "
                >
                  <v-chip
                    small
                    depressed
                    color="red"
                    class="white--text"
                    style="border-radius: 10px"
                    >Pay at store</v-chip
                  >
                </td>

                <td
                  v-else-if="
                    props.item.order_payment_method === 3 &&
                    props.item.order_type == 1
                  "
                >
                  <v-chip
                    small
                    depressed
                    color="red"
                    class="white--text"
                    style="border-radius: 10px"
                    >Pay at store (Partner)</v-chip
                  >
                </td>

                <td
                  v-else-if="
                    props.item.order_payment_method === 1 &&
                    props.item.order_type == 1
                  "
                >
                  <v-chip
                    small
                    depressed
                    color="green"
                    class="white--text"
                    style="border-radius: 10px"
                  >
                    Auto transfer</v-chip
                  >
                </td>
                <td v-else></td>
                <!-- <td
                  v-if="
                    (props.item.order_store != null &&
                      props.item.order_type == 1) ||
                      props.item.order_type == 2
                  "
                ></td> -->
                <td
                  colspan="10"
                  v-if="
                    props.item.order_store != null &&
                    (props.item.order_type == 1 || props.item.order_type == 3)
                  "
                >
                  <v-card flat color="transparent">
                    <v-card-text class="text-xs-left pl-0">
                      <ol>
                        <v-layout
                          row
                          wrap
                          v-for="(info, index) in props.item.order_store"
                          :key="index"
                        >
                          <v-flex xs2>
                            <li>{{ info.store_name }}</li>
                          </v-flex>
                          <v-flex xs4>
                            <ul style="list-style-type: none">
                              <li>
                                <div style="display: flex; align-items: center">
                                  <v-icon small class="pr-2"
                                    >new_releases</v-icon
                                  >
                                  <span>
                                    {{
                                      props.item.order_distance != null
                                        ? "Distance: " +
                                          props.item.order_distance +
                                          " m."
                                        : "ไม่ระบุระยะทาง"
                                    }}
                                  </span>
                                </div>
                                <!-- <span class="ml-2">
                                  {{
                                    info.store_order_time_end != null
                                      ? "เวลาคาดการณ์ : " +
                                        info.store_order_time_end.substring(
                                          11,
                                          16
                                        )
                                      : null
                                  }}
                                </span> -->
                              </li>
                            </ul>
                          </v-flex>
                          <!-- <v-flex xs4>
                            <span style="font-weight:bold;">AREA: </span>
                            {{ `${props.item.order_districts_name}` }}
                          </v-flex> -->
                        </v-layout>
                      </ol>
                    </v-card-text>
                  </v-card>
                </td>
              </tr>
            </template>

            <template slot="no-data"></template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import newOrderForm from "./NewOrderForm";
import messengerContractManager from "@/pages/back-office/Messenger/Contract/index.vue";
import realtimeDispatchSocket from "@/services/realtimeDispatchSocket";
import appConfigFeatureService from "@/services/appConfigFeatureService";
import { globalAxios } from "@/axios-path.js";
import { mapState, mapGetters } from "vuex";
import OrderIncentiveDialog from "./OrderIncentiveDialog.vue";
export default {
  props: ["order_status", "fetching_order"],
  components: {
    newOrderForm,
    messengerContractManager,
    OrderIncentiveDialog,
  },
  data: () => ({
    count: [],
    title: document.title,
    date1: new Date().toISOString().substr(0, 10),
    changing_status: [],
    tabs: null,
    contractDialog: false,
    contractCreditAlerts: [],
    contractCreditAlertPage: 0,
    dismissedContractCreditAlertBalances: {},
    contractCreditAlertTimer: null,
    loadingContractCreditAlerts: false,
    order_type_all: 1,
    type: [],
    statusOrderME: [
      { name: "Order made", value: 1 },
      { name: "In queue", value: 2 },
      { name: "On the way", value: 5 },
      { name: "Complete", value: 6 },
    ],
    statusOrderWE: [
      { name: "Order made", value: 1 },
      { name: "In queue", value: 2 },
      { name: "Cooking", value: 3 },
      { name: "Ready to pick up", value: 4 },
      { name: "On the way", value: 5 },
      { name: "Complete", value: 6 },
    ],
    headers: [
      {
        text: "Order code",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Customer",
        value: "role",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Timer inqueue",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Rider",
        align: "center",
        value: "name",
        sortable: false,
      },
      {
        text: "Dispatch Status",
        align: "center",
        value: "role",
        sortable: false,
      },
      // {
      //   text: "Store",
      //   align: "center",
      //   value: "role",
      //   sortable: false
      // },
      {
        text: "Promotion",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "Total",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "Payment",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "DatetimeOrder",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "DatetimeDelivery",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "role",
        sortable: false,
      },
    ],
    dispatchSocket: null,
    dispatchSocketState: "connecting",
    dispatchReconnectTimer: null,
    dispatchHeartbeatTimer: null,
    dispatchAuthenticated: false,
    joinedDispatchOrderIds: [],
    liveDispatchStatuses: {},
    dispatchHydrateTimer: null,
    dispatchHydrateInFlight: false,
    lastDispatchHydrateKey: "",
  }),

  computed: {
    ...mapState({
      order_count: (state) => state.fetchOrderListBack.order_count,
    }),
    ...mapGetters({
      isEditOrder: "isEditOrder",
    }),
    isAutoDispatchFeatureEnabled() {
      return appConfigFeatureService.isFeatureEnabled(
        "auto_dispatch_order_system",
        {
          defaultValue: true,
        }
      );
    },
    tableHeaders() {
      if (this.isAutoDispatchFeatureEnabled) {
        return this.headers;
      }
      return this.headers.filter((header) => header.text !== "Dispatch Status");
    },
    currentContractCreditAlert() {
      return this.contractCreditAlerts[this.contractCreditAlertPage] || null;
    },
    order_list() {
      return this.$store.state.fetchOrderListBack[
        "order_list_" + this.order_status
      ];
    },
    callCenterProvince() {
      return String(
        this.$route.params.province ||
          this.$store.state.backOffice.province ||
          ""
      )
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
    },
  },
  watch: {
    order_type_all() {
      this.count = [];
      document.title = this.$store.state.fetchGeneral.title;
      this.syncDispatchSubscriptions();
      this.scheduleHydrateDispatchStatuses();
    },
    order_list: {
      handler: function () {
        this.count = [];
        document.title = this.$store.state.fetchGeneral.title;
        if (this.order_list.length != 0) {
          if (this.order_status != 0) {
            if (this.order_list[0].order_status != this.order_status) {
              this.$store.commit("fetchOrderListBack/getOrderList", {
                order_status_id: this.order_status,
                res_data: [],
              });
            }
          }
        }
        this.syncDispatchSubscriptions();
        this.scheduleHydrateDispatchStatuses();
      },
    },
    callCenterProvince() {
      this.contractCreditAlertPage = 0;
      this.fetchContractCreditAlerts();
    },
    contractDialog(value, previousValue) {
      if (!value && previousValue) {
        this.fetchContractCreditAlerts();
      }
    },
  },

  created() {
    if (this.$store.state.fetchGeneral.title == null) {
      this.$store.commit("fetchGeneral/getTitle", this.title);
    }

    document.title = this.$store.state.fetchGeneral.title;
    this.initialize();
    if (this.isAutoDispatchFeatureEnabled) {
      this.connectDispatchSocket();
    }
  },
  beforeDestroy() {
    clearTimeout(this.dispatchHydrateTimer);
    clearInterval(this.contractCreditAlertTimer);
    this.disconnectDispatchSocket();
  },
  methods: {
    contractCreditAlertDismissalKey(alert) {
      const currentUser = this.$store.state.Info || {};
      const userId = currentUser.user_id || "anonymous";
      return [userId, this.callCenterProvince, alert.company_id].join(":");
    },
    contractCreditBalanceSignature(value) {
      const numericValue = Number(value);
      return Number.isFinite(numericValue)
        ? numericValue.toFixed(2)
        : String(value == null ? "" : value);
    },
    loadDismissedContractCreditAlerts() {
      try {
        const stored = window.localStorage.getItem(
          "weserve:contract-credit-alert-dismissals:v1"
        );
        const parsed = stored ? JSON.parse(stored) : {};
        this.dismissedContractCreditAlertBalances =
          parsed && typeof parsed === "object" && !Array.isArray(parsed)
            ? parsed
            : {};
      } catch (error) {
        this.dismissedContractCreditAlertBalances = {};
      }
    },
    saveDismissedContractCreditAlerts() {
      try {
        const dismissalKeys = Object.keys(
          this.dismissedContractCreditAlertBalances
        );
        const maximumStoredDismissals = 500;
        dismissalKeys
          .slice(0, Math.max(0, dismissalKeys.length - maximumStoredDismissals))
          .forEach((key) => {
            this.$delete(this.dismissedContractCreditAlertBalances, key);
          });
        window.localStorage.setItem(
          "weserve:contract-credit-alert-dismissals:v1",
          JSON.stringify(this.dismissedContractCreditAlertBalances)
        );
      } catch (error) {
        // The alert still stays dismissed for this page session when storage
        // is unavailable (for example, when the browser blocks localStorage).
      }
    },
    async fetchContractCreditAlerts() {
      const province = this.callCenterProvince;
      if (!province || this.loadingContractCreditAlerts) {
        if (!province) this.contractCreditAlerts = [];
        return;
      }
      this.loadingContractCreditAlerts = true;
      try {
        const currentCompanyId = this.currentContractCreditAlert
          ? this.currentContractCreditAlert.company_id
          : null;
        const response = await globalAxios.get(
          `/api/v1/mebf/${province}/contracts/credit_alerts`
        );
        const body =
          response && response.data
            ? response.data.data || response.data
            : response || {};
        this.loadDismissedContractCreditAlerts();
        let removedStaleDismissal = false;
        const alerts = (Array.isArray(body.alerts) ? body.alerts : []).filter(
          (alert) => {
            const dismissalKey = this.contractCreditAlertDismissalKey(alert);
            if (
              !Object.prototype.hasOwnProperty.call(
                this.dismissedContractCreditAlertBalances,
                dismissalKey
              )
            ) {
              return true;
            }
            const dismissedBalance =
              this.dismissedContractCreditAlertBalances[dismissalKey];
            const currentBalance = this.contractCreditBalanceSignature(
              alert.current_balance
            );
            if (dismissedBalance === currentBalance) return false;
            this.$delete(
              this.dismissedContractCreditAlertBalances,
              dismissalKey
            );
            removedStaleDismissal = true;
            return true;
          }
        );
        if (removedStaleDismissal) {
          this.saveDismissedContractCreditAlerts();
        }
        this.contractCreditAlerts = alerts;
        const currentCompanyIndex = alerts.findIndex(
          (alert) => alert.company_id === currentCompanyId
        );
        this.contractCreditAlertPage =
          currentCompanyIndex >= 0 ? currentCompanyIndex : 0;
      } catch (error) {
        this.contractCreditAlerts = [];
        this.contractCreditAlertPage = 0;
      } finally {
        this.loadingContractCreditAlerts = false;
      }
    },
    formatCreditAmount(value) {
      const numberValue = Number(value || 0);
      return numberValue.toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    showPreviousContractCreditAlert() {
      const total = this.contractCreditAlerts.length;
      if (total < 2) return;
      this.contractCreditAlertPage =
        (this.contractCreditAlertPage - 1 + total) % total;
    },
    showNextContractCreditAlert() {
      const total = this.contractCreditAlerts.length;
      if (total < 2) return;
      this.contractCreditAlertPage = (this.contractCreditAlertPage + 1) % total;
    },
    dismissCurrentContractCreditAlert() {
      const alert = this.currentContractCreditAlert;
      if (!alert) return;
      const dismissalKey = this.contractCreditAlertDismissalKey(alert);
      this.$delete(this.dismissedContractCreditAlertBalances, dismissalKey);
      this.$set(
        this.dismissedContractCreditAlertBalances,
        dismissalKey,
        this.contractCreditBalanceSignature(alert.current_balance)
      );
      this.saveDismissedContractCreditAlerts();
      this.contractCreditAlerts = this.contractCreditAlerts.filter(
        (item) => item.company_id !== alert.company_id
      );
      if (this.contractCreditAlertPage >= this.contractCreditAlerts.length) {
        this.contractCreditAlertPage = Math.max(
          this.contractCreditAlerts.length - 1,
          0
        );
      }
    },
    getDispatchGatewayBase() {
      return String(process.env.VUE_APP_REALTIME_GATEWAY_URL || "").trim();
    },
    getDispatchWebSocketUrl() {
      const gatewayBase = this.getDispatchGatewayBase();
      if (!gatewayBase) return "";
      try {
        const parsed = new URL(gatewayBase);
        parsed.protocol = parsed.protocol === "https:" ? "wss:" : "ws:";
        parsed.pathname = "/ws";
        parsed.search = "";
        parsed.hash = "";
        return parsed.toString();
      } catch (error) {
        return "";
      }
    },
    resolveDispatchOrderId(item) {
      return String(item?.order_code || item?.order_id || "").trim();
    },
    getVisibleDispatchOrderIds() {
      if (!this.isAutoDispatchFeatureEnabled) {
        return [];
      }
      return this.filtersItems(this.order_status)
        .map((item) => this.resolveDispatchOrderId(item))
        .filter(Boolean);
    },
    scheduleDispatchReconnect() {
      clearTimeout(this.dispatchReconnectTimer);
      this.dispatchReconnectTimer = setTimeout(() => {
        this.connectDispatchSocket();
      }, 3000);
    },
    startDispatchHeartbeat(socket) {
      this.stopDispatchHeartbeat();
      this.dispatchHeartbeatTimer = setInterval(() => {
        if (
          socket &&
          socket === this.dispatchSocket &&
          socket.readyState === WebSocket.OPEN
        ) {
          try {
            socket.send("ping");
          } catch (error) {
            // no-op
          }
        }
      }, 25000);
    },
    stopDispatchHeartbeat() {
      clearInterval(this.dispatchHeartbeatTimer);
      this.dispatchHeartbeatTimer = null;
    },
    getDispatchHydrateKey(orderIds) {
      return [...orderIds].sort().join("|");
    },
    scheduleHydrateDispatchStatuses(options = {}) {
      clearTimeout(this.dispatchHydrateTimer);
      this.dispatchHydrateTimer = setTimeout(() => {
        this.hydrateDispatchStatuses(options);
      }, 250);
    },
    async hydrateDispatchStatuses(options = {}) {
      const { force = false } = options;
      if (!this.isAutoDispatchFeatureEnabled) {
        return;
      }
      const gatewayBase = this.getDispatchGatewayBase();
      const token = localStorage.getItem("token") || "";
      const orderIds = this.getVisibleDispatchOrderIds();
      const hydrateKey = this.getDispatchHydrateKey(orderIds);

      if (!gatewayBase || !token || !orderIds.length) {
        return;
      }
      if (this.dispatchHydrateInFlight) {
        return;
      }
      if (!force && hydrateKey === this.lastDispatchHydrateKey) {
        return;
      }

      try {
        this.dispatchHydrateInFlight = true;
        const res = await fetch(`${gatewayBase}/dispatch/status/bulk`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ orderIds }),
        });
        const data = await res.json();
        if (!res.ok || !data?.ok || !Array.isArray(data.statuses)) {
          return;
        }
        this.lastDispatchHydrateKey = hydrateKey;

        data.statuses.forEach((payload) => {
          if (!payload?.orderId || !payload?.status) return;
          const orderId = String(payload.orderId).trim();
          this.$set(this.liveDispatchStatuses, orderId, {
            status: payload.status,
            radius: payload.radius,
            attempt: payload.attempt,
            checkedRiders: payload.checkedRiders,
          });
          this.$store.commit(
            "fetchOrderListBack/updateDispatchStatus",
            payload
          );
        });
      } catch (error) {
        // no-op
      } finally {
        this.dispatchHydrateInFlight = false;
      }
    },
    connectDispatchSocket() {
      if (!this.isAutoDispatchFeatureEnabled) {
        this.disconnectDispatchSocket(false);
        this.dispatchSocketState = "disabled";
        return;
      }
      const gatewayBase = this.getDispatchGatewayBase();
      const token = localStorage.getItem("token") || "";
      if (!gatewayBase || !token) {
        this.dispatchSocketState = "failed";
        return;
      }

      if (!this.dispatchSocketSubscription) {
        this.dispatchSocketSubscription = realtimeDispatchSocket.subscribe({
          onStateChange: (state) => {
            this.dispatchSocketState = state;
            this.dispatchAuthenticated = state === "connected";
            if (state === "connected") {
              this.syncDispatchSubscriptions();
              this.scheduleHydrateDispatchStatuses({ force: true });
            }
          },
          onDispatchStatus: (payload) => {
            this.applyLiveDispatchStatus(payload);
          },
        });
      }

      realtimeDispatchSocket.ensureConnection({
        gatewayBase,
        token,
      });
      this.syncDispatchSubscriptions();
    },
    disconnectDispatchSocket(allowClose = true) {
      clearTimeout(this.dispatchReconnectTimer);
      this.dispatchReconnectTimer = null;
      this.dispatchAuthenticated = false;
      this.joinedDispatchOrderIds = [];
      if (this.dispatchSocketSubscription) {
        this.dispatchSocketSubscription.dispose();
        this.dispatchSocketSubscription = null;
      }
      if (allowClose) {
        this.dispatchSocketState = "connecting";
      }
    },
    syncDispatchSubscriptions() {
      if (!this.dispatchSocketSubscription) {
        return;
      }

      const nextIds = this.getVisibleDispatchOrderIds();
      const currentIds = this.joinedDispatchOrderIds;
      const nextSet = new Set(nextIds);
      const currentSet = new Set(currentIds);

      currentIds.forEach((orderId) => {
        if (nextSet.has(orderId)) return;
        this.$delete(this.liveDispatchStatuses, orderId);
      });

      this.joinedDispatchOrderIds = nextIds;
      this.dispatchSocketSubscription.updateOrderIds(nextIds);
    },
    applyLiveDispatchStatus(payload) {
      const orderId = String(payload?.orderId || "").trim();
      if (!orderId) return;
      this.$set(this.liveDispatchStatuses, orderId, {
        status: payload?.status,
        radius: payload?.radius,
        attempt: payload?.attempt,
        checkedRiders: payload?.checkedRiders,
      });
      this.$store.commit("fetchOrderListBack/updateDispatchStatus", payload);
    },
    changeTitle() {
      if (this.count.length > 0) {
        var newTitle =
          "(" + this.count.length + ") " + this.$store.state.fetchGeneral.title;
      } else {
        var newTitle = this.$store.state.fetchGeneral.title;
      }
      document.title = newTitle;
    },
    NotiReadey(time, item) {
      if (
        time == 0 &&
        item.order_status == 1 &&
        !this.count.includes(item.order_id)
      ) {
        this.count.push(item.order_id);
      }
      this.changeTitle();
      return time;
    },
    amountCharTime(time) {
      return time.toString().length >= 2
        ? time.toString()
        : "0" + time.toString();
    },

    calTime(order_time_start, code) {
      var date1 = new Date();
      var date2 = new Date(order_time_start);
      var diff = 10 * 1000 + 2 * 60 * 1000 + date2.getTime() - date1.getTime();
      var msec = diff;
      var hh = Math.floor(msec / 1000 / 60 / 60);
      msec -= hh * 1000 * 60 * 60;
      var mm = Math.floor(msec / 1000 / 60);
      msec -= mm * 1000 * 60;
      var ss = Math.floor(msec / 1000);
      msec -= ss * 1000;
      return hh * 1000 * 60 * 60 + mm * 1000 * 60 + ss * 1000 > 0
        ? hh * 1000 * 60 * 60 + mm * 1000 * 60 + ss * 1000
        : 0;
    },
    checkIcon(status) {
      if (status == 1) {
        return "new_releases";
      } else if (status == 2) {
        return "list_alt";
      } else if (status == 3) {
        return "room_service";
      } else if (status == 4) {
        return "pan_tool";
      } else if (status == 5) {
        return "motorcycle";
      } else if (status == 6) {
        return "check_circle";
      } else if (status == 7) {
        return "cancel";
      } else if (status == 8) {
        return "check_circle";
      } else if (status == 9) {
        return "check_circle";
      }
    },
    checkCountOrder(value) {
      if (this.order_status == 1) {
        return this.order_count[value + "_order_status"]
          .order_status_order_made;
      } else if (this.order_status == 2) {
        return this.order_count[value + "_order_status"].order_status_in_queue;
      } else if (this.order_status == 3) {
        return this.order_count[value + "_order_status"].order_status_cooking;
      } else if (this.order_status == 4) {
        return this.order_count[value + "_order_status"]
          .order_status_ready_to_pick;
      } else if (this.order_status == 5) {
        return this.order_count[value + "_order_status"]
          .order_status_on_the_way;
      } else if (this.order_status == 6) {
        return this.order_count[value + "_order_status"].order_status_complete;
      } else if (this.order_status == 7) {
        return this.order_count[value + "_order_status"].order_status_cancel;
      } else if (this.order_status == 0) {
        return this.order_count[value + "_order_status"].order_status_preorder;
      }
    },
    async changeStatus(value, item, index) {
      if (item.order_type == 1 || item.order_type == 3) {
        let send_data = {
          status: value,
          item,
        };

        this.type[index] = [];
        this.changing_status.push(item.order_id);
        await this.$store.dispatch(
          "fetchOrderListBack/changeStatus",
          send_data
        );
        let findIndex = this.changing_status.findIndex(
          (val) => val == item.order_id
        );
        this.changing_status.splice(findIndex, 1);
      } else {
        let send_data = {
          status: value,
          item,
        };
        this.type[index] = [];
        this.changing_status.push(item.order_id);
        await this.$store.dispatch(
          "fetchOrderListBack/changeStatusME",
          send_data
        );
        let findIndex = this.changing_status.findIndex(
          (val) => val == item.order_id
        );
        this.changing_status.splice(findIndex, 1);
      }
      await this.$store.dispatch("fetchOrderListBack/getCountOrder");
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status
      );
    },
    checkLabel(status) {
      if (status == 1) {
        return "Order made";
      } else if (status == 2) {
        return "In queue";
      } else if (status == 3) {
        return "Cooking";
      } else if (status == 4) {
        return "Ready to pick up";
      } else if (status == 5) {
        return "On the way";
      } else if (status == 6) {
        return "Complete";
      } else if (status == 7) {
        return "Cancel";
      } else if (status == 8) {
        return "Pending";
      } else if (status == 9) {
        return "Store approving";
      }
    },
    filtersItems(value) {
      if (this.order_type_all == 1) {
        return this.order_list;
      } else if (this.order_type_all == 2) {
        let data = [];
        for (let key in this.order_list) {
          if (
            this.order_list[key].order_type == 1 ||
            this.order_list[key].order_type == 3
          ) {
            data.push(this.order_list[key]);
          }
        }
        return data;
      } else {
        let data = [];
        for (let key in this.order_list) {
          if (this.order_list[key].order_type == 2) {
            data.push(this.order_list[key]);
          }
        }
        return data;
      }
    },
    getDispatchState(item) {
      if (!item) return null;
      const resolvedOrderId = this.resolveDispatchOrderId(item);
      if (item.order_rider_id || item.order_rider_full_name) {
        return "assigned";
      }
      const liveStatus = this.liveDispatchStatuses[resolvedOrderId];

      if (liveStatus?.status) {
        const normalizedLiveStatus = String(liveStatus.status)
          .toLowerCase()
          .trim();
        if (
          normalizedLiveStatus === "searching" ||
          normalizedLiveStatus === "offering" ||
          normalizedLiveStatus === "offering_rider"
        ) {
          return "offering";
        }
        if (normalizedLiveStatus === "assigned") {
          return "assigned";
        }
        if (normalizedLiveStatus === "broadcast") {
          return "open_list";
        }
        if (normalizedLiveStatus === "manual") {
          return "manual";
        }
        if (normalizedLiveStatus === "failed") {
          return "failed";
        }
      }
      const raw =
        item.dispatch_state ||
        item.order_dispatch_state ||
        item.dispatchState ||
        item.dispatch_status ||
        item.dispatch_status_id;
      if (raw == null) return null;
      const normalized = String(raw).toLowerCase().trim();
      if (
        normalized === "searching" ||
        normalized === "offering" ||
        normalized === "offering_rider"
      ) {
        return "offering";
      }
      if (normalized === "assigned") {
        return "assigned";
      }
      if (
        normalized === "broadcast" ||
        normalized === "open_list" ||
        normalized === "openlist"
      ) {
        return "open_list";
      }
      if (normalized === "manual") {
        return "manual";
      }
      if (normalized === "failed") {
        return "failed";
      }
      return normalized;
    },
    dispatchStatusLabel(item) {
      if (!this.isAutoDispatchFeatureEnabled) return null;
      const state = this.getDispatchState(item);
      if (!state) return null;
      if (state === "offering") return "Offering Rider";
      if (state === "assigned") return "Assigned";
      if (state === "open_list") return "Open List";
      if (state === "manual") return "Manual";
      if (state === "failed") return "No Rider Accepted";
      return null;
    },
    dispatchStatusColor(item) {
      if (!this.isAutoDispatchFeatureEnabled) return "grey";
      const state = this.getDispatchState(item);
      if (!state) return "grey";
      if (state === "offering") return "orange";
      if (state === "assigned") return "green";
      if (state === "open_list") return "blue";
      if (state === "manual") return "red";
      if (state === "failed") return "red darken-2";
      return "grey";
    },
    initialize() {
      this.fetchContractCreditAlerts();
      this.contractCreditAlertTimer = setInterval(() => {
        this.fetchContractCreditAlerts();
      }, 60000);
    },
    toDetail(order_id) {
      this.$emit("setOrderID", order_id);
      this.$emit("detail", "orderDetail");
      this.$emit("hidePagename", false);
    },
    toMessengerDetail(order_id) {
      this.$emit("setOrderID", order_id);
      this.$emit("detail", "orderMessengerDetail");
      this.$emit("hidePagename", false);
    },
  },
};
</script>
<style>
.contract-shortcut-action {
  align-items: flex-start;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin: 2px 0 8px;
}

.contract-credit-bubbles {
  align-items: center;
  display: flex;
  flex-direction: column;
  max-width: 540px;
}

.contract-credit-bubble {
  align-items: flex-start;
  background: #fff9d7;
  border: 1px solid #f0cd21;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(74, 62, 0, 0.16);
  color: #3f3500;
  display: flex;
  font-size: 12px;
  line-height: 1.45;
  padding: 9px 34px 9px 10px;
  position: relative;
  text-align: left;
}

.contract-credit-bubble__close {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  height: 24px;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 5px;
  top: 4px;
  width: 24px;
}

.contract-credit-bubble__close:hover,
.contract-credit-bubble__close:focus {
  background: rgba(0, 0, 0, 0.08);
  outline: none;
}

.contract-credit-bubble__close .v-icon {
  color: currentColor !important;
}

.contract-credit-bubble::after {
  background: #fff9d7;
  border-right: 1px solid #f0cd21;
  border-top: 1px solid #f0cd21;
  content: "";
  height: 10px;
  position: absolute;
  right: -6px;
  top: 16px;
  transform: rotate(45deg);
  width: 10px;
}

.contract-credit-bubble--negative,
.contract-credit-bubble--zero {
  background: #ffe7e3;
  border-color: #e75b49;
  box-shadow: 0 8px 24px rgba(147, 31, 17, 0.2);
  color: #8f1f12;
}

.contract-credit-bubble--negative::after,
.contract-credit-bubble--zero::after {
  background: #fff0ed;
  border-color: #ef8d7e;
}

.contract-credit-bubble__icon {
  color: currentColor !important;
  margin: 1px 7px 0 0;
}

.contract-credit-bubble__hint {
  display: block;
  font-size: 11px;
  font-weight: 600;
  opacity: 0.78;
}

.contract-credit-pager {
  align-items: center;
  color: #665800;
  display: flex;
  font-size: 11px;
  font-weight: 700;
  gap: 2px;
  justify-content: center;
  margin-top: 4px;
}

.contract-credit-pager__button {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  height: 22px;
  justify-content: center;
  padding: 0;
  width: 22px;
}

.contract-credit-pager__button:hover,
.contract-credit-pager__button:focus {
  background: rgba(253, 223, 0, 0.22);
  outline: none;
}

.contract-credit-pager__position {
  min-width: 34px;
  text-align: center;
}

.credit-bubbles-enter-active {
  transition: opacity 320ms ease,
    transform 420ms cubic-bezier(0.2, 1.35, 0.45, 1);
}

.credit-bubbles-enter {
  opacity: 0;
  transform: translateX(24px) scale(0.86);
  transform-origin: right center;
}

.credit-bubbles-leave-active {
  transition: opacity 180ms ease, transform 180ms ease;
}

.credit-bubbles-leave-to {
  opacity: 0;
  transform: translateX(12px) scale(0.94);
}

.contract-shortcut-btn {
  border-radius: 8px;
  font-weight: 700;
  letter-spacing: 0;
  margin: 0 !important;
}

@media (max-width: 900px) {
  .contract-shortcut-action {
    align-items: flex-end;
    flex-direction: column-reverse;
  }

  .contract-credit-bubbles {
    max-width: 100%;
  }

  .contract-credit-bubble::after {
    display: none;
  }
}

.call-center-contract-dialog {
  border-radius: 20px;
  box-shadow: 0 28px 90px rgba(15, 23, 32, 0.28);
}

.call-center-glass-card {
  background: rgba(244, 247, 248, 0.84) !important;
  border: 1px solid rgba(255, 255, 255, 0.78) !important;
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
}

.shortcut-dialog-header {
  background: rgba(255, 255, 255, 0.54);
  min-height: 76px;
  padding: 16px 22px;
}

.shortcut-dialog-eyebrow {
  color: #9b8500;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.shortcut-dialog-title {
  color: #263238;
  font-size: 20px;
  font-weight: 700;
  margin-top: 3px;
}

.shortcut-dialog-content {
  max-height: calc(100vh - 130px);
  padding: 0px !important;
}

.tab-color {
  background-color: black;
  border-radius: 9px 9px 0px 0px;
  font-weight: 700;
}

.order-action-surface
  .v-btn:not(.v-btn--icon):not(.v-btn--floating):not(.v-btn--disabled) {
  border: 1px solid rgba(255, 255, 255, 0.58);
  border-radius: 24px;
  box-shadow: 0 8px 18px rgba(38, 50, 56, 0.18);
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.order-action-surface
  .v-btn:not(.v-btn--icon):not(.v-btn--floating):not(.v-btn--disabled):hover {
  box-shadow: 0 11px 24px rgba(38, 50, 56, 0.24);
  transform: translateY(-1px);
}

.order-action-surface .v-btn--icon {
  border: 1px solid rgba(255, 255, 255, 0.38);
  box-shadow: 0 6px 14px rgba(38, 50, 56, 0.14);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}
</style>
